import React from "react";

const Page404 = () => {
  return <div>Stran ne obstaja.</div>;
};

export default Page404;
